module.exports = __webpack_public_path__ + "img/pieles-arquitectonicas.cbd029b7.gif";